/**
 * @format
 */
import {guard, INTERFACE, IS_INPUT, IS_SELECT, IS_TEXTAREA} from '@acng/frontend-rubicon';
import {user} from 'acng/user/user';
import {FormController} from 'nova';
import {post} from './service/backend';
import {popup} from '@acng/frontend-discovery';
import {t} from 'acng/locale/config/translate';

class ContentRemoval extends FormController {
  /**
   * @param {HTMLFormElement} form
   */
  arrange(form) {
    ASSERT: guard(
      form.elements,
      INTERFACE({
        email: IS_INPUT,
        nickname: IS_INPUT,
        subject: IS_INPUT,
        category: IS_SELECT,
        description: IS_TEXTAREA,
      }),
    );

    const {email, nickname, subject, category, description} = form.elements;

    email.type = 'email';
    email.required = true;
    email.autocomplete = 'email';

    nickname.required = true;
    subject.readOnly = true;
    category.required = true;
    description.required = true;

    if (!user.guest) {
      email.defaultValue = user.email;
      email.readOnly = true;
      nickname.defaultValue = user.name;
      nickname.readOnly = true;
    }
  }

  /**
   * @param {HTMLFormElement} form
   * @param {FormData} data
   */
  async submit(form, data) {
    await post('complaint/content-removal', data, form);
    await popup().info(await t('core.contentRemoval.response.success'));
    form.reset();
  }
}

export {ContentRemoval};
